export type ServiceIssue = {
  description: string;
  id: number;
  preventsCreation: boolean;
  preventsSubmission: boolean;
  name: string;
};

export function canCreateService(
  entries: Array<{ issues: Array<ServiceIssue> }>,
) {
  return entries.every(
    (track) => !track.issues.some((issue) => issue.preventsCreation),
  );
}

export function canSubmitService(
  entries: Array<{ issues: Array<ServiceIssue> }>,
) {
  return entries.every(
    (track) => !track.issues.some((issue) => issue.preventsSubmission),
  );
}
